import revive_payload_client_4sVQNw7RlN from "/home/nobuhiro/developments/v2.renjuportal/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/nobuhiro/developments/v2.renjuportal/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/nobuhiro/developments/v2.renjuportal/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/nobuhiro/developments/v2.renjuportal/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/nobuhiro/developments/v2.renjuportal/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/nobuhiro/developments/v2.renjuportal/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/nobuhiro/developments/v2.renjuportal/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/nobuhiro/developments/v2.renjuportal/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/nobuhiro/developments/v2.renjuportal/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/home/nobuhiro/developments/v2.renjuportal/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/home/nobuhiro/developments/v2.renjuportal/.nuxt/sentry-client-config.mjs";
import plugin_Jozdw60ZsE from "/home/nobuhiro/developments/v2.renjuportal/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import documentDriven_cMiI6j6ghD from "/home/nobuhiro/developments/v2.renjuportal/node_modules/@nuxt/content/dist/runtime/legacy/plugins/documentDriven.js";
import auth_vT9JWWT9pN from "/home/nobuhiro/developments/v2.renjuportal/plugins/auth.ts";
import socket_client_qBDI6bzE0L from "/home/nobuhiro/developments/v2.renjuportal/plugins/socket.client.ts";
import vuetify_7h9QAQEssH from "/home/nobuhiro/developments/v2.renjuportal/plugins/vuetify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  plugin_Jozdw60ZsE,
  documentDriven_cMiI6j6ghD,
  auth_vT9JWWT9pN,
  socket_client_qBDI6bzE0L,
  vuetify_7h9QAQEssH
]